/**
 * Generates the color based on the userName.
 * @see https://github.com/mui/material-ui/blob/v5.13.7/docs/data/material/components/avatars/BackgroundLetterAvatars.tsx
 * @param userName - userName string.
 */
export const stringToColor = (userName: string) => {
    let hash = 0;

    for (let i = 0; i < userName.length; i += 1) {
        hash = userName.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (let i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }

    return color;
};

/**
 * Generates trimmed string.
 * @param value - value string.
 */
export const getTrimmedString = (value?: string): string => {
    return value ? value.trim() : '';
};
